var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckmarkCircledRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF5A60;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,180.2C3.1,82.7,83.3,3,181.4,3c99.4,0,178.7,79.8,178.2,180.2c-0.5,97.1-79.8,176.3-178,176.4 C82.3,359.7,3,280,3,180.2z M174.4,276.2c36.3-53.3,72.5-106.3,108.7-159.6c-13.2-10.1-26.1-20-39.1-30 c-27.1,39.9-53.7,79.1-80.5,118.7c-18.9-14.3-37.3-28.2-55.9-42.3c-9.3,13.2-18.5,26.2-27.9,39.4 C111.4,227.1,142.7,251.5,174.4,276.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkCircledRed);
export default __webpack_public_path__ + "static/media/iconCheckmarkCircledRed.8ecf73686e9c1447818f70af25f3cdd0.svg";
export { ForwardRef as ReactComponent };